import routes from 'global/Constants/routes';

import { lazy } from 'react';

const CustomerPage = lazy(() => import('../../pages/dashboard/customerManagement/customerList/CustomersPage'));

export const customerRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.customers.path,
    component: CustomerPage,
    isPrivate: routes.customers.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
